<template>
  <footer class="container text-sp-tertiary p-4 pb-6 mt-auto">
    <div class="flex flex-col justify-start gap-4 pt-4">
      <div class="flex flex-col gap-2 md:flex-row md:justify-center md:gap-6 underline underline-offset-2">
        <a href="https://nexters.com/en/terms_of_service" 
          @click="logClick('main.tosLink', 'main.footer')"
          class="hover:text-sp-accent duration-150 ease-in-out self-start"
        >
          Terms of Service
        </a>
        <a href="https://nexters.com/en/privacy_policy" 
          @click="logClick('main.policyLink', 'main.footer')"
          class="hover:text-sp-accent duration-150 ease-in-out self-start"
        >
          Privacy policy
        </a>
        <a :href="$t('hcLink')"
          @click="logClick('main.hcLink', 'main.footer')"
          class="hover:text-sp-accent duration-150 ease-in-out self-start"
        >
          Help Center
        </a>
        <a href="https://nexters.com/en/parents_guide" 
          @click="logClick('main.parentsGuideLink', 'main.footer')"
          class="hover:text-sp-accent duration-150 ease-in-out self-start"
        >
          Parent’s Guide
        </a>
        <a href="https://hwmobilefaq.com/faq/drop-rates/" 
          @click="logClick('main.dropRatesLink', 'main.footer')"
          class="hover:text-sp-accent duration-150 ease-in-out self-start"
        >
          Drop Rates
        </a>
      </div>

      <div class="flex justify-center gap-4">
        <a href="https://www.youtube.com/channel/UCR8PHhDezBphWktmiKyMxsA"
          @click="logClick('main.youtubeLink', 'main.footer')"
          class="footer-link"
        >
          <img src="@/assets/icon-social-youtube.png" alt="Youtube" class="footer-image">
        </a>
        <a href="https://www.instagram.com/herowarsapp/"
          @click="logClick('main.instagramLink', 'main.footer')"
          class="footer-link"
        >
          <img src="@/assets/icon-social-instagram.png" alt="Instagram" class="footer-image">
        </a>
        <a href="https://www.facebook.com/herowarsalliance"
          @click="logClick('main.fbLink', 'main.footer')" 
          class="footer-link"
        >
          <img src="@/assets/icon-social-facebook.png" alt="Facebook" class="footer-image">
        </a>
        <a href="https://discord.gg/emhVzgQR66"
          @click="logClick('main.discordLink', 'main.footer')"
          class="footer-link"
        >
          <img src="@/assets/icon-social-discord.png" alt="Discord" class="footer-image">
        </a>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useLogger } from '../composables/useLogger'
const { logClick } = useLogger()
</script>

<style scoped>
.footer-link {
  width: 36px; 
  height: 36px; 
  transition: 150ms ease-in-out;
}

@media (hover: hover) {
 .footer-link:hover {
    transform: scale(1.1);
  }
}
</style>